import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Vant from '@femessage/vant';
import '@femessage/vant/lib/index.css';
import { ImagePreview } from '@femessage/vant';
import '@vant/touch-emulator';
// 全局注册
Vue.use(ImagePreview);
Vue.use(Vant);
Vue.config.productionTip = false
var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?15fd797f1ae4e695d64e7a200fb22c72";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
